const validate = {
  /* 合法uri*/
  validateURL: (textval) => {
    const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
    return urlregex.test(textval)
  },
  /* 只能输入数字以及小数点,小数点后两位*/
  validatTwoNumber: (str) => {
    const reg = /^\d+(\.\d{0,2})?$/;
    return reg.test(str)
  },

};

export default validate;



// WEBPACK FOOTER //
// ./src/utils/validate.js